module.exports = __webpack_public_path__ + "fonts/fixicons.51bb33b6.eot";